import { Dialog, DialogTitle, DialogContent, Typography, DialogActions, Button } from "@mui/material";


export function IdleWarningDialog(props: {
    open: boolean;
    secondsLeft: number;
    onStay: () => void;
    onLogout: () => void;
}){
    return(
        <Dialog open={props.open} disableEscapeKeyDown> 
            <DialogTitle>Session Timeout</DialogTitle>
            <DialogContent>
                <Typography>
                    You have been inactive. You will be logged out in {props.secondsLeft}s.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onLogout}>Log Out Now</Button>
                <Button variant="contained" onClick={props.onStay}>
                    Stay Logged In
                </Button>
            </DialogActions>
        </Dialog>
    )
}